var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chart-container" },
    [
      _c("div", { staticClass: "chartjs-size-monitor" }),
      _vm._v(" "),
      _c("Bar", {
        attrs: { "chart-options": _vm.options, "chart-data": _vm.chartData }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }